import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".section4 .swiper", {
    slidesPerView: 7,
    spaceBetween: '2.22%',
    loop:true,
    speed:5000,//匀速时间
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 7,
            spaceBetween: '2.22%',
        },
        768: {  //当屏幕宽度小于等于1280
            slidesPerView: 4,
            spaceBetween: '2.22%',
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }, 
});